import { create } from "zustand";

export const MICROPHONE_FALLBACK_WARNING_DISMISSED_KEY =
  "microphoneFallbackWarningDismissed";

const readDismissed = () => {
  try {
    return (
      window.localStorage.getItem(MICROPHONE_FALLBACK_WARNING_DISMISSED_KEY) ===
      "true"
    );
  } catch {
    return false;
  }
};

type MicrophoneBannerDismissalState = {
  isDismissed: boolean;
  syncFromStorage: () => void;
  dismiss: () => void;
  reset: () => void;
};

// タブを閉じてもログインは継続するため、次回ログイン成功時に解除するまで保持する。
// マイク設定や録音状態とは独立させ、保存できない環境でも画面上では閉じられるようにする。
export const useMicrophoneBannerDismissal =
  create<MicrophoneBannerDismissalState>((set) => ({
    isDismissed: readDismissed(),
    syncFromStorage: () => set({ isDismissed: readDismissed() }),
    dismiss: () => {
      set({ isDismissed: true });
      try {
        window.localStorage.setItem(
          MICROPHONE_FALLBACK_WARNING_DISMISSED_KEY,
          "true",
        );
      } catch {
        return;
      }
    },
    reset: () => {
      set({ isDismissed: false });
      try {
        window.localStorage.removeItem(
          MICROPHONE_FALLBACK_WARNING_DISMISSED_KEY,
        );
      } catch {
        return;
      }
    },
  }));
